import React from 'react';
import { inRange } from 'lodash';
import LogoMakerBriefCarousel from '@fiverr-private/variations_display/src/components/MarketplaceBrief';
import { MEDIA_GRID_LG, MEDIA_GRID_MD } from '../utils/constants';
import { LOGO_MAKER_BANNER_INDEX } from '../components/common/listings/constants';

const getLogoMakerBannerConfig = ({ isTouch, showListViewCards, shouldShowBanner = false }) => {
    if (!shouldShowBanner) { return {}; }

    const logoMakerBanner = (<LogoMakerBriefCarousel isTouch={isTouch}
        source="marketplace"
        target="_blank"/>);

    const mdMediaQueryTop = Number.parseInt(MEDIA_GRID_LG, 10),
        mdMediaQueryBottom = Number.parseInt(MEDIA_GRID_MD, 10);
    const isWindowInMDMediaQuery = inRange(window && window.innerWidth, mdMediaQueryBottom, mdMediaQueryTop);

    const cardViewBannerIndex = (isWindowInMDMediaQuery ?
        LOGO_MAKER_BANNER_INDEX.TABLET :
        LOGO_MAKER_BANNER_INDEX.DESKTOP);

    const logoMakerBannerConfig = {
        bannerIndex: showListViewCards ? LOGO_MAKER_BANNER_INDEX.MOBILE : cardViewBannerIndex,
        bannerClassName: 'logo-maker-banner'
    };

    return {
        logoMakerBanner,
        logoMakerBannerConfig
    };
};

export default getLogoMakerBannerConfig;
